import React from 'react';
import { Chip, type ChipProps } from '@mui/material';
import {
  getProviderPlaceDisplayColor,
  providerPlaceColorSx,
  type ProviderPlaceColorSource,
} from '../utils/providerPlaceColor';

type ProviderPlaceChipProps = Omit<ChipProps, 'label'> & {
  place?: ProviderPlaceColorSource | null;
  label: string;
};

const ProviderPlaceChip: React.FC<ProviderPlaceChipProps> = ({
  place,
  label,
  size = 'small',
  variant = 'outlined',
  sx,
  ...rest
}) => {
  const color = getProviderPlaceDisplayColor(place);
  const tone = providerPlaceColorSx(color);

  return (
    <Chip
      label={label}
      size={size}
      variant={variant}
      sx={{
        fontWeight: 600,
        borderWidth: 1.5,
        ...tone,
        ...sx,
      }}
      {...rest}
    />
  );
};

export default ProviderPlaceChip;
